import { AudioTimingContext } from '@rhg/providers/audio';
import { useContext } from 'react';

/**
 * Subscribe to the high-frequency audio timing (timingState + currentCue).
 *
 * Updates at the ~4Hz `timeupdate` cadence during playback, so use it ONLY in
 * the scrubber / timeline / subtitle UI that genuinely needs live timing.
 * Everything that only cares about play/pause/track identity should read the
 * low-frequency `useAudio()` context instead. EVE-12668.
 */
export function useAudioTiming() {
    return useContext(AudioTimingContext);
}
